module.exports = __webpack_public_path__ + "699eba4588e8fcf358a2def4356218a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/toOrder.png
// module id = 490
// module chunks = 0